type EventHandler<T = unknown> = (payload: T) => void;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type InternalHandler = (payload: any) => void;

class EventBus {
  private events = new Map<string, Set<InternalHandler>>();

  on<T>(event: string, handler: EventHandler<T>): void {
    if (!this.events.has(event)) {
      this.events.set(event, new Set());
    }
    this.events.get(event)!.add(handler);
  }

  off<T>(event: string, handler?: EventHandler<T>): void {
    if (handler) {
      this.events.get(event)?.delete(handler);
    } else {
      this.events.delete(event);
    }
  }

  emit<T>(event: string, payload?: T): void {
    this.events.get(event)?.forEach((handler) => handler(payload));
  }
}

export const eventBus = new EventBus();
